import {
  Grid,
  FormControl,
  InputBase,
  MenuItem,
  Select,
  Toolbar,
  Typography,
} from "@material-ui/core";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import moment from "moment";
import PropTypes from "prop-types";
import PickerMonth from "../../../partials/pickerMonth";
// Style
import { toolbarStyles } from "./styles";

class EnhancedTableToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      to: moment(),
      from: moment().subtract(3, "months"),
      // .format("MM/YYYY")
    };
    this.typeOrder = ["new", "processing", "done", "cancel"];
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  async componentDidMount() {
    const _this = this;
    await Promise.all([
      this.props.orderDispatch.getLatestDate(),
      this.props.orderDispatch.getOldestDate(),
    ]);
    let oldestDate = this.props.orderState.oldestDate;
    let lastestDate = this.props.orderState.lastestDate;
    this.setState({ to: lastestDate, from: oldestDate }, function () {
      _this.props.fetchData(_this.state.from, _this.state.to, _this.state.type);
    });
  }
  handleChangeDate(value, name) {
    const _this = this;
    this.setState({ [name]: value }, function () {
      _this.props.fetchData(_this.state.from, _this.state.to, _this.state.type);
    });
  }
  handleChange(event) {
    const _this = this;
    this.setState({ [event.target.name]: event.target.value }, function () {
      _this.props.fetchData(_this.state.from, _this.state.to, _this.state.type);
    });
  }
  render() {
    const { classes, t } = this.props;
    const { from, to } = this.state;
    return (
      <Toolbar className={classes.root}>
        <Grid container spacing={3}>
          <Grid item md={12} sm={12}>
            <Grid
              container
              spacing={3}
              alignItems="center"
              className={classes.marginSpacing}
            >
              <Grid item md={6} sm={6} xs={12}>
                <div className={classes.title}>
                  <Typography
                    color="inherit"
                    variant="h6"
                    className={classes.titleText}
                  >
                    {t("dashboard_order_toolbar_total")} {this.props.total}{" "}
                    {t("dashboard_order_toolbar_orders")}
                  </Typography>
                </div>
              </Grid>
              <Grid
                item
                md={6}
                sm={6}
                xs={12}
                className={classNames(
                  classes.containerInput,
                  classes.fixPaddingContainerInput
                )}
              >
                <Typography
                  color="inherit"
                  variant="body1"
                  className={classes.label}
                >
                  {t("dashboard_order_toolbar_type")}
                </Typography>
                <div
                  className={classNames(
                    classes.inputBase,
                    classes.fixMarginInputBase
                  )}
                >
                  <FormControl className={classes.formControl}>
                    <Select
                      value={this.state.type}
                      onChange={this.handleChange}
                      input={
                        <InputBase
                          fullWidth
                          style={{ textTransform: "capitalize" }}
                          classes={{
                            root: classNames(
                              classes.inputRootSelected,
                              classes.inputRoot
                            ),
                            input: classNames(
                              classes.inputInputSelected,
                              classes.inputInput
                            ),
                          }}
                        />
                      }
                      displayEmpty
                      classes={{
                        select: classes.selected,
                      }}
                      name="type"
                      className={classes.selectType}
                    >
                      <MenuItem value="">
                        {t("dashboard_order_toolbar_all_orders")}
                      </MenuItem>
                      {this.typeOrder.map((type, index) => (
                        <MenuItem
                          key={index}
                          value={type}
                          style={{ textTransform: "capitalize" }}
                        >
                          {t(type)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} sm={12}>
            <Grid container spacing={3}>
              <Grid item sm={6} className={classes.containerInput}>
                <Typography
                  color="inherit"
                  variant="body1"
                  className={classes.label}
                >
                  {t("dashboard_order_toolbar_from")}
                </Typography>
                <div className={classes.inputBase}>
                  <PickerMonth
                    handleChange={this.handleChangeDate}
                    nameInput="from"
                    time={from}
                  />
                </div>
              </Grid>
              <Grid item sm={6} className={classes.containerInput}>
                <Typography
                  color="inherit"
                  variant="body1"
                  className={classes.label}
                >
                  {t("dashboard_order_toolbar_to")}
                </Typography>
                <div className={classes.inputBase}>
                  <PickerMonth
                    handleChange={this.handleChangeDate}
                    nameInput="to"
                    time={to}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    );
  }
}

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  orderState: state.order,
});

const mapDispatch = (dispatch) => ({
  orderDispatch: dispatch.order,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(toolbarStyles)(EnhancedTableToolbar)));
